import type { WorkItem } from "./types";

/**
 * 「在途」列表分拣:真在跑的 vs 近期失败的(2026-09-20)。
 *
 * ★为什么需要:屏卡 P1(0910)把近 24h FAILED 的一键长图作业放进了 `listRunning`
 *   (此前整个滤掉 = 关页即失联),但只改了数据层 —— 两个消费点(WorksPage / InFlightRow)
 *   照旧把**每一条**都画成 `MediaInProgressCard`,而那张卡的转圈图标和「已等待 N 分钟」
 *   是写死的。0920 测试机实况:两张「没排成」的卡顶着转圈挂在「进行中 (3)」里,
 *   要挂满 24 小时;失败原因卡上还看不到。
 * ★口径:只认 FAILED。其余状态原样留在在途(PENDING/RUNNING/官媒 GENERATING……),
 *   不拿 `isTaskActive` 反推 —— 那会把它不认识的词汇误判成「失败」。
 */
export function splitInFlight(items: WorkItem[]): { active: WorkItem[]; failed: WorkItem[] } {
  const active: WorkItem[] = [];
  const failed: WorkItem[] = [];
  for (const w of items) (w.status === "FAILED" ? failed : active).push(w);
  return { active, failed };
}
